import React from "react";
import {
  TableContainer,
  Paper,
  IconButton,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { isMobile } from "../../globalStyles/mobile";
import { ActionTableCellComponent } from "../action-table-component";
import { styled, Switch } from "@mui/material";
import { wmsService } from "../../utils/services/wmsProvider";

const WarehouseList = ({
  data,
  onEditData,
  onViewWmsData,
  handleDeleteClick,
  addButton,
  refreshData,
}) => {
  const GreenRedSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase": {
      "&.Mui-checked": {
        color: "var(--success-green)", // Green knob
        "& + .MuiSwitch-track": {
          backgroundColor: "var(--success-green)", // Green track
        },
      },
      "&:not(.Mui-checked)": {
        color: "var(--error-red)", // bright red knob
        "& + .MuiSwitch-track": {
          backgroundColor: "var(--error-red)", // bright red track
        },
      },
    },
  }));
  const handleDefaultWarehouseToggle = async (selectedId) => {
    try {
      await wmsService.edit(
        {
          default_warehouse: true,
        },
        selectedId,
      );

      const others = data.filter(
        (w) => w._id !== selectedId && w.default_warehouse,
      );
      await Promise.all(
        others.map((item) =>
          wmsService.edit(
            {
              default_warehouse: false,
            },
            item._id,
          ),
        ),
      );
      refreshData && refreshData();
    } catch (error) {
      console.error("Failed to update default warehouse:", error);
    }
  };

  const MobileCardView = ({ data }) => {
    return (
      <TableContainer sx={{ mt: 1 }} component={Paper}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            background: "var(--primary-blue)",
            justifyContent: "space-between",
            padding: 1,
            alignItems: "center",
          }}
        >
          <CustomTypography
            fontSize={14}
            sx={{ fontWeight: "600", textAlign: "center", flexGrow: 1 }}
          >
            {`WAREHOUSE LIST`}
          </CustomTypography>
          {data?.length ? (
            <IconButton
              style={{
                color: "var(--primary-blue)",
                padding: 0,
                background: "var(--primary-blue)33",
                height: 30,
                width: 30,
                borderRadius: 5,
                marginLeft: 15,
                boxShadow: "0px 0px 4px 0px #00000040",
                marginTop: 5,
              }}
              aria-label="edit"
              onClick={() => {
                onEditData && onEditData(data);
              }}
            >
              <BorderColorIcon sx={{ height: 20, width: 20 }} />
            </IconButton>
          ) : null}
        </Box>

        {data?.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              borderBottom: "0.5px solid var(--border-color)",
              padding: 1,
            }}
          >
            <Box
              sx={{
                width: "50%",
                display: "flex",
                border: "0.5px solid var(--border-color)",
                background: "var(--hover-bg)",
                justifyContent: "center",
                alignItems: "center",
                padding: 1,
                fontSize: 13,
                fontFamily: "Poppins",
              }}
            >
              <Typography>{`Warehouse ${index + 1}`}</Typography>
            </Box>
            <Box
              sx={{
                width: "50%",
                display: "flex",
                border: "0.5px solid var(--border-color)",
                justifyContent: "center",
                alignItems: "center",
                padding: 1,
                fontSize: 13,
                fontFamily: "Poppins",
              }}
            >
              {item?.provider?.name}
            </Box>

            <Box
              sx={{
                width: "50%",
                display: "flex",
                border: "0.5px solid var(--border-color)",
                background: "var(--hover-bg)",
                justifyContent: "center",
                alignItems: "center",
                padding: 1,
                fontSize: 13,
                fontFamily: "Poppins",
              }}
            >
              Consignor
            </Box>
            <Box
              sx={{
                width: "50%",
                display: "flex",
                border: "0.5px solid var(--border-color)",
                justifyContent: "center",
                alignItems: "center",
                padding: 1,
                fontSize: 13,
                fontFamily: "Poppins",
              }}
            >
              {item?.consignor_name}
            </Box>
          </Box>
        ))}
      </TableContainer>
    );
  };
  return isMobile() ? (
    <MobileCardView data={data} />
  ) : (
    <TableContainer
      sx={{
        overflow: "auto",
        mt: 1,
        maxHeight: 500,
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Soft shadow
        border: "1px solid var(--border-color)", // Light grey border
        borderRadius: "8px", // Rounded corners for a cleaner look
      }}
      component={Paper}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                fontWeight: "600",
                backgroundColor: "var(--table-header-bg)",
              }}
            >
              Provider
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "600",
                backgroundColor: "var(--table-header-bg)",
              }}
            >
              Name
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "600",
                backgroundColor: "var(--table-header-bg)",
              }}
            >
              Warehouse Code
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "600",
                backgroundColor: "var(--table-header-bg)",
              }}
            >
              Consignor
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "600",
                backgroundColor: "var(--table-header-bg)",
              }}
            >
              Default
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "600",
                backgroundColor: "var(--table-header-bg)",
              }}
            >
              {addButton}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data
            ?.map((item) => ({
              ...item,
              action: (
                <ActionTableCellComponent
                  selectedData={item}
                  handleViewClick={(data) =>
                    onViewWmsData && onViewWmsData(data)
                  }
                  handleEditClick={(data) => onEditData && onEditData(data)}
                  handleDeleteClick={(data) =>
                    handleDeleteClick && handleDeleteClick(data)
                  }
                ></ActionTableCellComponent>
              ),
            }))
            .map((item, i) => (
              <TableRow
                sx={{
                  backgroundColor:
                    i % 2 === 0 ? "var(--row-bg-odd)" : "var(--row-bg-even)",
                }}
                key={i}
              >
                <TableCell>{item?.provider?.name}</TableCell>
                <TableCell>{item?.name}</TableCell>
                <TableCell>{item?.warehouse_code}</TableCell>
                <TableCell>{item?.consignor_name}</TableCell>
                <TableCell>
                  <GreenRedSwitch
                    size="small"
                    checked={item?.default_warehouse || false}
                    onChange={() => handleDefaultWarehouseToggle(item._id)}
                  />
                </TableCell>
                <TableCell sx={{ paddingLeft: 6, display: "flex" }}>
                  {item.action}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WarehouseList;
